export default "__VITE_ASSET__ss_2d2Ov__"